import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { TypeaheadMatch } from "ngx-bootstrap";
import { ControlContainer } from "@angular/forms";
import { StrutturaVO } from "@app/shared/vo/strutturaVO";
import { OrganoService } from "@app/shared/services/organo.service";

@Component({
  selector: "app-ricerca-struttura-form",
  templateUrl: "./ricerca-struttura-form.component.html",
})
export class RicercaStrutturaFormComponent implements OnInit {
  public typeaheadLoading: boolean;
  public typeaheadNoResults: boolean;
  public asyncStrutturaSelected: string;
  public strutturaBool: boolean = false;
  public formGroup;
  public dataSource: Observable<any>;

  @Output()
  emettiStruttura: EventEmitter<StrutturaVO> = new EventEmitter<StrutturaVO>();

  @Input() placeholder: string;

  constructor(
    private controlContainer: ControlContainer,
    private organoService: OrganoService
  ) {
    // classifica
    this.dataSource = Observable.create((observer: any) => {
      // Runs on every search
      observer.next(this.asyncStrutturaSelected);
    }).pipe(
      switchMap((token: string) => this.organoService.getCMU(String(token)))
    );
    //
  }

  ngOnInit(): void {
    this.formGroup = this.controlContainer.control;
  }

  public changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  public changeTypeaheadNoResults(e: boolean): void {
    this.strutturaBool = false;
    this.typeaheadNoResults = e;
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    this.emettiStruttura.emit(e.item);
  }

  public creaEntryStruttura(codice: string, nome: string): StrutturaVO {
    let appoggioNome: string;
    const entry = new StrutturaVO();
    entry.id = codice;
    entry.nome = nome;
    if (entry.nome.length > 58) {
      appoggioNome = entry.nome.substring(0, 58) + "...";
    } else {
      appoggioNome = entry.nome;
    }
    entry.output = entry.id + " - " + appoggioNome;
    return entry;
  }

  public rimuoviStruttura() {
    this.asyncStrutturaSelected = "";
    this.emettiStruttura.emit(null);
  }
}
